/*
 * @Author: bbqin
 * @Date: 2022-10-19 16:28:11
 * @LastEditTime: 2023-08-31 18:15:18
 * @LastEditors: bbqin
 * @Description: 如果我没写，可能我忘了。如果我忘了，可能我没看。如果我没看，可能我没写。
 * @FilePath: \Platform_Front\src\platform\components\MetaFieldSetting\setting\adapter\core\field.js
 * (混沌)足够多的方案才能接近真实的结果。
 */

import React, { Component } from "react";
import { Input, Tooltip } from "@platform/base";
import { match } from '../../libs/utils';
import classnames from 'classnames';
import { getSysFieldid } from '@platform/api';

/**
 * 左侧的属性面板
 */
class Field extends Component {
    constructor(props) {
        super(props);
    }

    /**
     * 查询
     * @param {*} value 
     * @param {*} e 
     */
    onSearch = (value, e) => {
        const { store, code } = this.props;
        const fieldStore = store.getStore(['coreData', 'field']) || {};
        const { data = [] } = fieldStore;

        const nextData = data.map(item => {
            const { label } = item;
            // 是否是过滤的
            item.filtered = match(label, value);
            return item;
        });

        store.setStore(['coreData', 'field', 'value'], value, false);
        store.setStore(['coreData', 'field', 'data'], nextData, true);
        // TODO search
        // scrollIntoView 聚焦到首项
    }

    render() {

        const { store, code } = this.props;
        const langJson = store.getStore('langJson');
        const fieldStore = store.getStore(['coreData', 'field']) || {};
        const { value, data = [] } = fieldStore;

        return <div
            className="field-wrapper"
            fieldid={getSysFieldid('left_area')}
        >
            <div className="field-search">
                <span className="field-search-label">{langJson['field-list-title'] || '待添加'}</span>
                <Input
                    className="field-search-input"
                    placeholder={langJson['setting-search-placeholder'] || '请搜索'}
                    type="search"
                    value={value}
                    onChange={this.onSearch}
                    // onSearch
                    showClose
                />
            </div>
            <ul className="field-list">
                {data.map((item, i) => {
                    const { attrcode } = item;
                    return <ListItem key={attrcode} areaCode={code} store={store} {...item} />;
                })}
            </ul>
        </div>;
    }
}

const getIconClass = (fontName, another) => {
    return `icon iconfont icon-${fontName} ${another}`;
};

class ListItem extends Component {
    constructor(props) {
        super(props);
    }

    // 左侧点击选中
    onTransferToView = e => {
        const { store, areaCode, attrcode } = this.props;
        let nextViewSourceItem = null;
        {
            // 左边移除一个
            const fieldStore = store.getStore(['coreData', 'field']) || {};
            const { value, data = [] } = fieldStore;
            const nextData = data.filter(item => {
                const { label, attrcode: currentCode } = item;
                if (currentCode === attrcode) {
                    // 记录数据
                    nextViewSourceItem = item;
                    return false;
                } else {
                    // 是否是过滤的
                    item.filtered = match(label, value);
                    return true;
                }
            });
            store.setStore(['coreData', 'field', 'data'], nextData, false);
        }
        {
            // 右边添加一个
            const viewStore = store.getStore(['coreData', 'view']) || {};
            const { value, data = [] } = viewStore;
            // 显示
            nextViewSourceItem.iscoredata = true;
            let nextData = nextViewSourceItem ? [...data, nextViewSourceItem] : data;

            nextData = nextData.map(item => {
                const { label } = item;
                // 是否是过滤的
                item.filtered = match(label, value);
                return item;
            });
            store.setStore(['coreData', 'view', 'data'], nextData, true);
        }
    };

    // 点击高亮显示
    onHighlight = ele => {
        // 左侧点击高亮，移动到右侧，并且高亮
        const { store, areaCode, attrcode } = this.props;
        let nextViewSourceItem = null;
        {
            // 左边移除一个
            const fieldStore = store.getStore(['coreData', 'field']) || {};
            const { value, data = [] } = fieldStore;
            const nextData = data.filter(item => {
                const { label, attrcode: currentCode } = item;
                if (currentCode === attrcode) {
                    // 记录数据
                    nextViewSourceItem = item;
                    return false;
                } else {
                    // 是否是过滤的
                    item.filtered = match(label, value);
                    return true;
                }
            });
            store.setStore(['coreData', 'field', 'data'], nextData, false);
        }
        {
            // 右边添加一个
            const viewStore = store.getStore(['coreData', 'view']) || {};
            const { value, data = [] } = viewStore;

            let nextData = data;
            if (nextViewSourceItem) {
                let viewLockedItems = [];
                let viewUnLockedItems = [];
                data.forEach(item => {
                    if (item.islock) {
                        viewLockedItems.push(item);
                    } else {
                        viewUnLockedItems.push(item);
                    }
                });
                // nextData = [...viewLockedItems, ...viewUnLockedItems, { ...nextViewSourceItem, ishighlight: true, iscoredata: true }];
                nextData = [...viewLockedItems, ...viewUnLockedItems, { ...nextViewSourceItem, isbold: true, iscoredata: true }];
            }

            nextData = nextData.map(item => {
                const { label } = item;
                // 是否是过滤的
                item.filtered = match(label, value);
                return item;
            });

            store.setStore(['coreData', 'view', 'data'], nextData, true);
        }
    };

    render() {
        const {
            store,
            // 是否展示了
            showItem,
            filtered,
            label,
            required,
            noDeletion,
            redstar,
            ishighlight,
            isbold,
            islock,
            visible
        } = this.props;
        const langJson = store.getStore('langJson');
        const uncontrolledVisible = store.getStore(['config', 'uncontrolledVisible']);

        return <li className="field-item">
            <div
                className={classnames({
                    'field-item-filtered': filtered,
                    'field-item-content': true,
                    'show-highlight': isbold,
                })}
            >
                {/* {required && <span className="unselected-mark iconfont icon-xinghao"></span>} */}
                <span className="field-label" title={label}>{label}</span>
                {!uncontrolledVisible &&
                    <span className="field-icon" onClick={this.onTransferToView}>
                        <Tooltip
                            placement="top"
                            overlay={langJson['action-icon-add']}
                            delayHide={1}
                            delayShow={1000}
                        >
                            <i className={getIconClass('ncc-sq', 'close')} />
                        </Tooltip>
                    </span>
                }

                {/* <span className="field-icon icon-highlight" onClick={this.onHighlight}>
                    <Tooltip
                        placement="top"
                        overlay={langJson['action-icon-light']}
                        delayHide={1}
                        delayShow={1000}
                    >
                        <i className={getIconClass('tgaoliang', isbold ? 'activated' : 'close')} />
                    </Tooltip>
                </span> */}
            </div>
        </li>;
    }
}

export default Field;